import { OrgAccountTypes, YesNoEmpty } from '@interfaces/models';
import { createAction, props } from '@ngrx/store';
import { OrgTriageState } from '@store/reducers/org/org.reducer';

export const ClearOrgState = createAction('[Org] Clear Org State');

export const UpdateOrgAccountTypeSelection = createAction(
  '[Org] Update Org Account Type Selection',
  props<{ payload: OrgAccountTypes }>(),
);

export const UpdateOrgAuthorityTypeSelection = createAction(
  '[Org] Update Org Authority Selection',
  props<{ payload: YesNoEmpty }>(),
);

export const UpdateOrgTriage = createAction(
  '[Org] Update Org Triage',
  props<{ payload: Partial<OrgTriageState> }>(),
);

export const OrgTriageContinue = createAction('[Org Triage] Continue');
